<template>
  <div>
    Display OCR Here...
  </div>
</template>

<script>
export default {
  name: 'OCR',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
